/**
 * CanvasRegressionFillRow — `canvas.regression-fill` renderer.
 * Fills the space above/below symmetric threshold rules (center ±
 * offset) around the kernel-smoothed regression curve — red above the
 * top rule, blue below the bottom rule.
 */
import { Json } from "../../core/json.ts";
import { RendererRow } from "./renderer-row.ts";

/**
 * The `canvas.regression-fill` painter row: fills above and below threshold rules around a series'
 * regression curve.
 */
export class CanvasRegressionFillRow extends RendererRow {
  get seriesKey(): string {
    return Json.string(this.attrs(), "key") ?? "default";
  }

  /** Distance from center to each fill rule (in `offsetType` units). */
  get offset(): number {
    return Json.number(this.attrs(), "offset") ?? 0;
  }
}
